import {
  CHARACTER_REQUEST,
  SERVER_REQUEST,
  SERVER_GROUP_REQUEST,
  SERVER_GROUP_NAME_REQUEST,
} from '../mutations_type.js'
import { ROLE_API, SERVER_API } from '../../services/api/api.js'

import axios from 'axios'
import router from '@/router'
import { routerErrror } from '../../services/route-navigation.js'

const header = {
  headers: {
    Authorization: 'Bearer ' + localStorage.getItem('token'),
  },
}

const state = {
  servers: [],
  group_name: [],
  groups: [],
  characters: [],
}

const getters = {
  SERVERS: state => {
    return state.servers
  },
  GROUP_NAME: state => {
    return state.group_name
  },
  GROUPS: state => {
    return state.groups
  },
  CHARACTERS: state => {
    return state.characters
  },
}

const mutations = {
  [SERVER_REQUEST]: (state, payload) => {
    state.servers = payload
  },
  [CHARACTER_REQUEST]: (state, payload) => {
    state.characters = payload
  },
  [SERVER_GROUP_NAME_REQUEST]: (state, payload) => {
    state.group_name = payload
  },
  [SERVER_GROUP_REQUEST]: (state, payload) => {
    state.groups = payload
  },
}

const actions = {
  [SERVER_REQUEST]: ({ commit }, payload) => {
    const { game_id } = payload
    axios
      .get(SERVER_API.replace('{game_id}', game_id), header)
      .then(response => {
        const data = response.data
        const servers = data.data
        if (data.code === 0 && servers) {
          // sort server theo id tăng dần
          servers.sort(function(a, b) {
            return b.id - a.id
          })
          // Đảo ngược mảng servers
          servers.reverse()
          // Group mảng servers thành 10 mảng nhỏ
          let index = 0
          const arrayLength = servers.length
          const result = []

          for (index = 0; index < arrayLength; index += 10) {
            const myChunk = servers.slice(index, index + 10)
            result.push(myChunk)
          }

          const groupsArray = []
          // Thêm thành phần vào 1 emenent trong mảng và tạo ra mảng mới
          result.forEach(element => {
            const group = [
              {
                name: `Cụm server ${result.indexOf(element) * 10 +
                  1} - ${result.indexOf(element) * 10 + 1 + 9}`,
                list: element,
              },
            ]

            groupsArray.push(...group)
          })
          commit('SERVER_GROUP_REQUEST', groupsArray)
          // Lấy ra mảng theo tên
          commit(
            'SERVER_GROUP_NAME_REQUEST',
            groupsArray.map(v => v.name)
          )
        }
      })
      .catch(err => {
        const data = err.response.data
        commit('SERVER_REQUEST', [])
        commit('CHARACTER_REQUEST', [])
        if (data === 'unauthorized') {
          commit('AUTH_LOGOUT')
          router.push('/login').catch(routerErrror)
          commit(
            'MESSAGE_ERROR',
            'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại',
            { root: true }
          )
        }
      })
  },
  [CHARACTER_REQUEST]: ({ commit }, payload) => {
    const game_id = payload.game_id
    const server_id = payload.server_id
    axios
      .get(
        ROLE_API.replace('{game_id}', game_id).replace(
          '{server_id}',
          server_id
        ),
        header
      )
      .then(response => {
        const data = response.data
        const characters = data.data
        if (data.code === 0 && characters) {
          commit('CHARACTER_REQUEST', characters)
        }
      })
      .catch(err => {
        const data = err.response.data
        console.log('Lỗi lấy danh sách nhân vật: ', data)
        commit('CHARACTER_REQUEST', [])
      })
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
